import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";

const realAuthClient = createAuthClient({
  plugins: [
    inferAdditionalFields({
      user: {
        discordUserId: {
          type: "string",
          required: false,
          input: false,
        },
        accessTier: {
          type: ["free", "staff", "admin"],
          required: false,
          defaultValue: "free",
          input: false,
        },
        dailyQuotaLimit: {
          type: "number",
          required: false,
          defaultValue: 15,
          input: false,
        },
        dailyQuotaRemaining: {
          type: "number",
          required: false,
          defaultValue: 15,
          input: false,
        },
        dailyQuotaResetAt: {
          type: "string",
          required: false,
          input: false,
        },
        lastInteractionAt: {
          type: "string",
          required: false,
          input: false,
        },
      },
    }),
  ],
});

const localDevSession = {
  user: {
    id: "local-dev-user",
    name: "Local Dev",
    email: "local-dev@astrolens.local",
    image: null,
    discordUserId: "local-dev-discord",
    accessTier: "admin",
    dailyQuotaLimit: 9999,
    dailyQuotaRemaining: 9999,
    dailyQuotaResetAt: null,
    lastInteractionAt: null,
  },
  session: {
    id: "local-dev-session",
    userId: "local-dev-user",
    token: "local-dev-token",
    createdAt: new Date(0),
    updatedAt: new Date(0),
    expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30),
  },
};

function useLocalDevSession() {
  return {
    data: localDevSession,
    isPending: false,
    error: null,
    refetch: async () => localDevSession,
  } as unknown as ReturnType<typeof realAuthClient.useSession>;
}

export const authClient = import.meta.env.DEV
  ? (({
      ...realAuthClient,
      useSession: useLocalDevSession,
      signIn: {
        ...realAuthClient.signIn,
        social: async () => ({ redirect: false, url: "" }),
      },
      signOut: async () => ({ data: null, error: null }),
    } as unknown) as typeof realAuthClient)
  : realAuthClient;
